/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_Detail_FieldsInputs */

const en_audit_detail_fields = /** @type {(inputs: Audit_Detail_FieldsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fields`)
};

const pt_br2_audit_detail_fields = /** @type {(inputs: Audit_Detail_FieldsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Campos`)
};

/**
* | output |
* | --- |
* | "Fields" |
*
* @param {Audit_Detail_FieldsInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const audit_detail_fields = /** @type {((inputs?: Audit_Detail_FieldsInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Detail_FieldsInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_audit_detail_fields(inputs)
	return pt_br2_audit_detail_fields(inputs)
});